<!-- Component for select tag       -->
<script>
// import eventbus from '@src/state/EventBus'

export default {
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance

  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'input',
  },
  props: {
    value: {
      type: String,
      default() {
        return null
      },
    },
    label: {
      type: String,
      default() {
        return ''
      },
    },
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    valid: {
      type: Boolean,
      default() {
        return false
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    name: {
      type: String,
      default() {
        return ''
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    form: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      selected: null,
    }
  },

  computed: {
    option() {
      return this.options.options !== undefined ? this.options.options : []
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.selected !== this.value) {
          var x = this.option.findIndex((y) => y.code === this.value)

          if (x !== -1) {
            this.selected = this.value
            this.callDependency(this.value, false)
          }
        }
      }
    },
  },
  beforeDestroy() {
    var doc = this.$refs['select' + this.name]
    if (doc !== undefined) doc.innerHtml = ''
  },
  mounted() {
    if (this.selected !== this.value) {
      var x = this.option.findIndex((y) => y.code === this.value)

      if (x !== -1) {
        this.selected = this.value
        this.callDependency(this.value, false)
      }
    }
  },

  methods: {
    callDependency(data, event) {
      if (
        this.options.dependency !== undefined &&
        this.options.dependency !== null
      ) {
        var parent = this

        if (
          this.options.dependency.find((element) => element === data) !==
          undefined
        ) {
          setTimeout(() => {
            parent.$root.$emit(this.name, {
              name: this.name,
              value: data,
              status: event,
            })
          }, 1000)
        } else {
          //    console.log('here in else')
          setTimeout(() => {
            parent.$root.$emit(this.name, {
              name: this.name,
              value: data,
              status: event,
            })
          }, 1000)
        }
      }
    },
    sendData(event) {
      // eventbus.$emit('testEvent', 'test')

      //    eventbus.$emit('testEvent', 'validate_all')
      this.$refs[this.name].reset()
      this.$emit('update', event.target.value)
      this.selected = event.target.value
      this.callDependency(event.target.value, true)
    },
  },
}
// v-validate.disable="'required'"
</script>

<template
  ><div :ref="'select' + name">
    <div :class="$style.formGroup" class="formGroup mt20 mt10-sm">
      <div class="formFieldWrap">
        <label
          :for="name"
          :class="$style.fieldTitle"
          class="w40 w100-sm FL pr15 pr0-sm"
          >{{ label }}</label
        >
        <div class="form-field w60 w100-sm FL">
          <div :class="$style.options">
            <ValidationProvider
              :ref="name"
              v-slot="{ errors }"
              mode="passive"
              :vid="name"
              :name="name"
              :rules="validation"
            >
              <select
                :id="name"
                :value="selected"
                :name="name"
                @change="sendData"
              >
                <option
                  v-for="(opt, index) in option"
                  :key="index"
                  :value="opt.code"
                  >{{ opt.label }}</option
                >
              </select>

              <span v-show="errors[0]" :class="$style.error">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <span :class="$style.infoText">{{ options.info }}</span>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.infoText {
  display: block;
  font-size: 11px;
  font-style: italic;
  line-height: 14px;
  color: #8c959f;
}

.formGroup {
  max-width: 500px;
}
</style>
